import { render, staticRenderFns } from "./CompanyContactsManager.vue?vue&type=template&id=4b40698a&scoped=true"
import script from "./CompanyContactsManager.vue?vue&type=script&lang=js"
export * from "./CompanyContactsManager.vue?vue&type=script&lang=js"
import style0 from "./CompanyContactsManager.vue?vue&type=style&index=0&id=4b40698a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40698a",
  null
  
)

export default component.exports